namespace Matrix.Workflow {
    export class WorkflowInstanceDocumentColumns {
        static columnsKey = 'Workflow.WorkflowInstanceDocument';
    }
}
